import React from 'react';
import { FormContainer } from '../../../styles';
import { Field, getFormValues, reduxForm, SubmissionError } from 'redux-form';
import { COUPON_FORM_NAME, TRANSACTION_SUMMARY_SCREEN } from '../../../utils/constants';
import { activateLoader, disableLoader, scrollToError } from '@Redux/actions/ui-trigger';
import { connect } from 'react-redux';
import { ICouponCodeProps } from '../../../utils/interface';
import { required } from '@Utils/validation';
import { CommonButton, OutlinedTextFields } from '@Components';
import {
  niumForexTransactionComputation,
  storeTransactionDetails
} from '@Redux/actions/nium-forex';
import { IStore } from '../../../../../store.type';
import { getComputedCurrency } from '../utils';
import { NF_PAYMENT_COUPON_EVENT } from '../../../../../utils/constants/eventsConstants';
import { FLOW_TYPE } from '../../../../../utils/constants';
import { NF_SCREENS } from '../../../root/screenConstants';
import { logEvent } from '../../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../../utils/events/eventsConstants';

const CouponForm: React.FC<ICouponCodeProps> = ({
  getAllformVal,
  handleSubmit,
  onClose,
  sourceAmount,
  sourceCurrency,
  destinationCurrency,
  disableLoader,
  activateLoader,
  storeTransactionDetails,
  reasonForTransfer,
  sourceOfFunds,
  fieldChangeCallback,
  netSourceAmount,
  remittanceType
}) => {
  const handleCouponSubmit = async () => {
    const { isError, sourceAmount: updateSourceAmount } = await getComputedCurrency(
      sourceAmount,
      '',
      destinationCurrency,
      getAllformVal.coupon_code,
      activateLoader,
      disableLoader,
      sourceCurrency,
      destinationCurrency,
      storeTransactionDetails,
      reasonForTransfer,
      sourceOfFunds,
      remittanceType
    );
    if (isError) {
      throw new SubmissionError({ coupon_code: TRANSACTION_SUMMARY_SCREEN.errors.invalidCoupon });
    } else {
      const ctData = {
        pageNme: NF_SCREENS.transaction_summary,
        destinationCurrency,
        couponCode: getAllformVal?.coupon_code
      };
      logEvent(NF_PAYMENT_COUPON_EVENT, FLOW_TYPE.TRANSACTION, ctData, LOG_TYPE.CLEVER_TAP);
      if (updateSourceAmount && updateSourceAmount !== netSourceAmount) fieldChangeCallback(true);
      onClose(true);
    }
  };

  return (
    <FormContainer>
      <form className="coupon-form-container" onSubmit={handleSubmit(handleCouponSubmit)}>
        <Field
          bindToThisObject={getAllformVal?.coupon_code}
          parentClassName="form-text-field"
          type="text"
          name="coupon_code"
          component={OutlinedTextFields}
          maxWidth="450px"
          validate={[required]}
          disableUnderlineStyling={true}
          showLabel={true}
          placeholder={TRANSACTION_SUMMARY_SCREEN.couponCode.placeHolder}
        />
        <div className="button-container">
          <CommonButton text="Apply coupon" width={418} disabled={!getAllformVal?.coupon_code} />
        </div>
        <div className="button-container">
          <CommonButton text="Cancel" type="link" onClick={() => onClose(true)} />
        </div>
      </form>
    </FormContainer>
  );
};

const createreduxForm = reduxForm({
  form: COUPON_FORM_NAME,
  onSubmitFail: scrollToError
});

function mapStateToProps(reduxState: IStore) {
  const getAllformVal = getFormValues(COUPON_FORM_NAME)(reduxState);
  const {
    rootReducer: {
      niumForexReducer: {
        transactionDetails: {
          couponCode,
          sourceCurrency,
          destinationCurrency,
          sourceAmount,
          reasonForTransfer,
          sourceOfFunds,
          netSourceAmount,
          remittanceType
        }
      }
    }
  } = reduxState;
  return {
    couponCode,
    sourceCurrency,
    destinationCurrency,
    sourceAmount,
    getAllformVal,
    reasonForTransfer,
    sourceOfFunds,
    netSourceAmount,
    remittanceType
  };
}
const CouponCodeForm = createreduxForm(CouponForm);

export default connect(mapStateToProps, {
  niumForexTransactionComputation,
  disableLoader,
  activateLoader,
  storeTransactionDetails
})(CouponCodeForm);
